import {
  UNSET_NEW_MESSAGE_INDICATOR_ON_MOBILE
} from '../action_types'

export default () => ({type: UNSET_NEW_MESSAGE_INDICATOR_ON_MOBILE})



/** WEBPACK FOOTER **
 ** ./modules/shared/data/actions/unset_new_message_indicator_on_mobile.js
 **/